module.exports = __webpack_public_path__ + "assets/img/tx101t.2088265e.jpg";